<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Tags"
    type-modal="feed_post_tag_modal"
  >
    <div class="modal-content__main">
      <d-form>

        <d-form-row>
          <!-- Filter Name -->
          <d-col md="12" class="form-group">
            <label>Nova tag</label>
            <div class="d-flex align-items-center">
              <autocomplete
                ref="tag"
                placeholder="Nova tag"
                item-show="name"
                :items="tags"
                :parameter="model"
                :on-input="onInput"
                :on-select="setTag"
                :on-blur="setTagBlur"
              ></autocomplete>
              <i class="fas fa-plus ml-2" @click="addTag"></i>
            </div>
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Hastags -->
          <d-col class="form-group mb-0">
            <d-list-group flush class="list-group-small">
              <d-list-group-item v-for="(row, index) in post.tags" :key="index" class="d-flex px-3 border-bottom-1">
                <span class="text-semibold text-fiord-blue pl-0">{{ row.name }}</span>
                <span class="ml-auto text-right text-semibold px-0">
                  <i class="fas fa-minus" @click="removeRow(index)"></i>
                </span>
              </d-list-group-item>
            </d-list-group>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-3"
      >Fechar</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import FeedService from '_services/rest/modules/feed';
import ModalTemplate from '_shared/Modal.vue';
import { _LOAD_FEED_TAG_, TAG_MODEL, POST_MODEL, _CLOSED_FEED_TAG_ } from '../FeedModel';

export default {
  name: 'feed-filter-modal',
  components: {
    Autocomplete,
    ModalTemplate,
  },
  props: {},
  data() {
    return {
      loading: false,
      model: { ...TAG_MODEL },
      post: cloneDeep(POST_MODEL),
      tags: [],
      arrayPosts: [],
    };
  },
  computed: {
    token() {
      const { authResponse } = this.$store.state.feed;
      if (authResponse) {
        return authResponse.access_token;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    addTag() {
      setTimeout(() => {
        if (this.model.name) {
          this.post.tags.push(this.model);
          this.model = cloneDeep(TAG_MODEL);
          this.$refs.tag.$refs.input.value = '';
        }
      }, 50);
    },
    close() {
      this.post = cloneDeep(POST_MODEL);
      this.setToggle({ type: 'feed_post_tag_modal', bool: false });
    },
    getPost(post) {
      this.post = post;
      this.post.reference_id = post.id;
      this.post.id = null;
      FeedService.getTagsPost(this.post.reference_id, this.token)
        .then(response => {
          this.post = { ...response, ...this.post };
          this.post.id = response.id;
          this.post.tags = response.tags;
          return this.post;
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message}`, theme: 'danger' });
        });
    },
    onInput(search) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        FeedService.getTags(search)
          .then(response => {
            this.tags = response;
          });
      }, 500);
    },
    removeRow(index) {
      this.post.tags.splice(index, 1);
    },
    save() {
      if (Object.keys(this.arrayPosts).length > 0) {
        FeedService.saveTagsArrays(this.post.tags, this.arrayPosts)
          .then(this.success)
          .catch(() => this.activeAlert({ message: 'Ocorreu um erro ao salvar', theme: 'danger' }));
      } else {
        FeedService.saveTags(this.post)
          .then(this.success)
          .catch(() => this.activeAlert({ message: 'Ocorreu um erro ao salvar', theme: 'danger' }));
      }
    },
    setTag(tag) {
      this.model = tag;
    },
    setTagBlur(tag, model) {
      model.name = tag;
    },
    success() {
      this.activeAlert({ message: 'Tags salvas com sucesso', theme: 'success' });
      Events.$on(_CLOSED_FEED_TAG_);
      this.close();
    },
  },
  mounted() {
    Events.$on(_LOAD_FEED_TAG_, ({ array, post }) => {
      if (!array) {
        this.getPost(post);
      } else {
        this.post = { ...POST_MODEL };
        this.arrayPosts = { ...post };
      }
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
